import { StyleSheet } from 'aphrodite';
import { grayIconFill } from '../../../../styles/colors';
import { SPACE } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	form: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	label: {
		fontSize: 14,
		fontWeight: 500,
	},
	hint: {
		fontSize: 12,
		color: grayIconFill,
	},
	footer: {
		gap: SPACE[8],
		justifyContent: 'space-between',
	},
	toggleRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
});
